import { Component } from '@angular/core';
import { CourseContentDisplayComponent } from '../course-content-display/course-content-display.component';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-course-content-display-splash-only',
  templateUrl: './course-content-display-splash-only.component.html',
  styleUrls: ['./course-content-display-splash-only.component.scss']
})
export class CourseContentDisplaySplashOnlyComponent extends CourseContentDisplayComponent {
  constructor(
    ucdService: UserCourseDataService
  ) {
    super(ucdService);
  }

  ngOnInit() {
  }
}
